import { Box, Button, Checkbox, Container, FormControlLabel, InputAdornment, Modal, Stack, Switch, TextField } from "@mui/material";
import React, { useState, useEffect, useRef, useContext } from "react";
import Datastore from "../../../store/hoa-datastore";
import dayjs from 'dayjs';
import DollarIcon from '@mui/icons-material/AttachMoney';
import LinkIcon from '@mui/icons-material/Link';
import UploadIcon from '@mui/icons-material/CloudUpload';
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';
import LoadingButton from "@mui/lab/LoadingButton";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import { isValidHttpUrl } from "../../../utility/input-field-validation";
import { GlobalContext } from '../../../context/hoa-global-context';
import PDFsContainerComponent from "../../pdf-container-component/hoa-pool-access-form-pdf-container";
import Autocomplete from '@mui/material/Autocomplete';
import config from '../../../hoa-config';
import CustomDateField from "../../../Container/custom-date-field";
import SourceIdVerificationModal from "./common/SourceIdVerificationModal";
import useFieldDisabled from "../../../hooks/useFieldDisabled";

export default function HoaProcedureForm(props: any) {

    const { isProceduresFieldDisabled } = useFieldDisabled();
    const { sourceDocumentsFiles, selectedValues, updateSelectedValues} = useContext<any>(GlobalContext);
    const{view,sourceDocuments,setSourceDocuments,setCurrentHoa,currentHoa,checkProcedureWarning, setBasicFormState} =props

    const [open, setOpen] = useState(false);
    const [documentName,setDocumentName]=useState('')
    const [toBeDelete,setToBeDelete]=useState({})
    const [selectedKeywords, setSelectedKeywords] = useState([]);
    const [categories, setCategories] = useState([]);
    const [flag, setFlag] = useState(true);
    const [sourceFileInfo, setSourceFileInfo] = useState([]);
	const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const handleKeywordChange = (event:any, value:any) => {
        setSelectedKeywords(value);
    }

    const handleCurrentChange = (event: any) => {
        if(event.target.name === 'leasingCap' && event.target.value === false) {
            const tmpState = {
                ...currentHoa,
                'procedures': {
                    ...currentHoa['procedures'],
                    [event.target.name]: event.target.value,
                    'AdditionalInformationOfLeasingCap': '',
                }
            }
            setCurrentHoa({...tmpState});
            setBasicFormState({...tmpState});
            checkProcedureWarning(tmpState);
            return;
        }
        const tmpState = {
            ...currentHoa,
            'procedures': {
                ...currentHoa['procedures'],
                [event.target.name]: event.target.value
            }
        }
        setCurrentHoa({...tmpState})
        setBasicFormState({...tmpState})
        checkProcedureWarning(tmpState);
    }

    const handleDateChange = (value: any, key: string) => {
        props.setCurrentHoa({
            ...props.currentHoa,
            'procedures': {
                ...props.currentHoa['procedures'],
                'leasingRestrictionDate': value
            }
        })
    }

    const updateKeywordsAndCategoriesInsideState = (keywords: any, categories: any) => {
        if (categories.length > 0 && keywords.length > 0) {
            const tmpState = {
                ...currentHoa,
                'procedures': {
                    ...currentHoa['procedures'],
                    ['keywords']: keywords,
                    ['categories']: categories
                }
            }
            // if(!categories.length && tmpState.procedures.categories) {
            //     delete tmpState.procedures.keywords;
            //     delete tmpState.procedures.categories;
            // }
            setCurrentHoa({...tmpState})
            setBasicFormState({...tmpState})
            checkProcedureWarning(tmpState);
        }
    }

    const Wheel = (e: any) => {
        e.target.blur();
    }

    const deleteClick = (document: string, file: any) => {
        setDocumentName(document);
		setToBeDelete(file);
		setOpen(!open);
	}

    const handleClose = () => {
        setOpen(!open);
    }
    
    const state = props.currentHoa.procedures || {};

    useEffect(() => {
        if (sourceDocuments.length > 0) {
            setSourceFileInfo(sourceDocuments)
        } 
    }, [])

    useEffect(() => {
        if (flag && state.leasingRegulationsAndRestrictions) {
            setFlag(false);
            
            if (state && state.keywords) {
                setSelectedKeywords(state.keywords);
            }
            else {
                generateAndSaveKeywords(state.leasingRegulationsAndRestrictions);
            }
        }
        else {
            generateAndSaveKeywords(state.leasingRegulationsAndRestrictions);
        }
    }, [state.leasingRegulationsAndRestrictions]);

    useEffect(() => {
        const selectedCategories:any = [];
        const uniqueSelectedCategories:any = [];
        
        const leasingRestrictionsAndRegulationsCategory = config.leasingRestrictionsAndRegulationsCategory;

        for (const keyword of selectedKeywords) {
            selectedCategories.push(leasingRestrictionsAndRegulationsCategory[keyword]);
        }

        for (const selectedCategory of selectedCategories) {
            if (uniqueSelectedCategories.indexOf(selectedCategory) === -1) {
                uniqueSelectedCategories.push(selectedCategory);
            }
        }

        updateKeywordsAndCategoriesInsideState(selectedKeywords, uniqueSelectedCategories);
        setCategories(uniqueSelectedCategories);
    }, [selectedKeywords]);

    const generateAndSaveKeywords = (leasingRegulationsAndRestrictions:any) => {
        const currentKeywords: any = [];

        if (!leasingRegulationsAndRestrictions) {
            return currentKeywords;
        }

        for (const keyword of config.leasingRestrictionsAndRegulationsKeywords) {
            if (keyword == 'Rental cap (from x% to y%)') {
                if (leasingRegulationsAndRestrictions.toLowerCase().includes(keyword.toLowerCase())
                || leasingRegulationsAndRestrictions.toLowerCase().includes(("Rental cap (from ").toLowerCase())) {
                    currentKeywords.push(keyword);
                }
            }
            else if (keyword == 'Owner occupied for # years') {
                if (leasingRegulationsAndRestrictions.toLowerCase().includes(keyword.toLowerCase())
                || leasingRegulationsAndRestrictions.toLowerCase().includes(('Owner occupied for ').toLowerCase())) {
                    currentKeywords.push(keyword);
                }
            }
            else if (keyword == 'Must own for # years before leasing') {
                if (leasingRegulationsAndRestrictions.toLowerCase().includes(keyword.toLowerCase())
                || leasingRegulationsAndRestrictions.toLowerCase().includes((' years before leasing').toLowerCase())) {
                    currentKeywords.push(keyword);
                }
            }
            else if (leasingRegulationsAndRestrictions.toLowerCase().includes(keyword.toLowerCase())) {
                currentKeywords.push(keyword);
            }
        }
        const uniqueKeyWords = [...new Set([...selectedKeywords, ...currentKeywords])];
        
        setSelectedKeywords(uniqueKeyWords);
    }

    const renderCategories = () => {
        if (categories.length == 0) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '12px', borderRadius: '5px', border: '1px solid #E8E8E8', background: '#FAFAFA', padding: '8px', fontSize: '12px', fontWeight: '500', color: '#3E3E3E' }}>
                    N/A
                </div>
            )
        }

        const categoryList:any = [];
        for (const category of categories) {
            categoryList.push(
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '12px', borderRadius: '5px', border: '1px solid #E8E8E8', background: '#FAFAFA', padding: '8px', fontSize: '12px', fontWeight: '500', color: '#3E3E3E' }}>
                    {category}
                </div>
            )
        }

        return categoryList;
    }

	const addNewSourceDocument = () => {
		const newSource = {
			isVerified: false,
			sourceId: '',
			sourceIdType: ''
		}
		setSourceFileInfo((prev) => [newSource, ...prev]);
	}

    const deleteSourceDocument = (index: number) => {
		setSourceFileInfo((prev) => prev.filter((item, idx) => idx !== index));
        setSourceDocuments((prev: any) => prev.filter((item: any, idx: number) => idx !== index));
    }

	const handleSourceFile = (event: any, index: number) => {
		const {name, value} = event.target;
		const tempState = [...sourceFileInfo];
		tempState[index][name] = value;
		if (name === 'files' && value.length > 0) {
			tempState[index]['isVerified'] = true;
        } else if (name === 'files' && value.length == 0) {
			tempState[index]['isVerified'] = false;
        }
		setSourceFileInfo(tempState);
	}

    const toggleAttachDocumentModal = () => {
        setIsOpen(!isOpen);
        if(sourceFileInfo.length == 0) {
            addNewSourceDocument();
        }
    }

    const onUploadClick = () => {
        if(sourceFileInfo.length > 0) {
            setSourceDocuments(sourceFileInfo);
            setIsOpen(!isOpen);
        }
    }

    const isAllVerified = sourceFileInfo.every((item: any) => item.isVerified);

    return (
        <div
            style={{
                width: "100%",
                height: window.innerHeight - Datastore.responsiveHeightWithtab,
                overflowY: 'scroll',
                borderRadius: "4px",
                fontSize: '20px'
            }}
            className="add-municipality-form-container">
            <div style={{ width: '623px' }}>
                <main style={{ margin: '32px 24px' }}>
                    <div>
                        <span className="sub-title-text">HOA Registration Renewal Information</span>
                        <div style={{ borderBottom: '1px solid  #E8E8E8', marginTop: '32px', display: 'flex', flexDirection: 'column' }}>
                            <span className="text-14px-5B5B5B">Registration & Renewal Instructions</span>
                            <TextField
                                style={{ width: "75%", marginBottom: "24px", marginTop: '20px' }}
                                variant="outlined"
                                name='registrationAndRenewalInstruction'
                                value={state.registrationAndRenewalInstruction || ""}
                                onChange={handleCurrentChange}
                                label="Write here..."
                                multiline
                                InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }}
                                InputProps={{ style: { minHeight: "106px" } }}
                                disabled={isProceduresFieldDisabled('registrationAndRenewalInstruction')}
                            />
                        </div>
                        <div style={{ borderBottom: '1px solid  #E8E8E8', marginTop: '20px' }}>
                            <TextField
                                style={{ width: "280px", }}
                                value={state.renewalFee || ""}
                                onWheel={e => Wheel(e)}
                                variant='standard'
                                type='number'
                                onChange={handleCurrentChange}
                                label="Renewal Fee"
                                name='renewalFee'
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                disabled={isProceduresFieldDisabled('renewalFee')}
                                InputProps={{
                                    style: { padding: "7px 0px" },
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <DollarIcon />
                                        </InputAdornment>
                                    )
                                }} />

                            <TextField
                                style={{
                                    padding: "10px 0px",
                                    marginTop: "17px",
                                    width: "433px",
                                    marginBottom: '24px'
                                }}
                                multiline
                                variant="standard"
                                label={'Additional Information'}
                                name='AdditionalInformationOfRenewalFee'
                                value={state.AdditionalInformationOfRenewalFee || ""}
                                type='text'
                                onChange={handleCurrentChange}
                                onWheel={e => Wheel(e)}
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                InputProps={{ style: { padding: "7px 0px" } }}
                                disabled={isProceduresFieldDisabled('AdditionalInformationOfRenewalFee')}
                            />
                        </div>
                    </div>
                    <div style={{ marginTop: '15px' }}>
                        <span style={{ marginBottom: '32px' }} className="sub-title-text">Hoa Leasing Regulations & Restrictions</span>
                        <Stack style={{ borderBottom: '1px solid  #E8E8E8', marginTop: '20px' }} direction={'column'} justifyContent={'space-between'}>
                            <TextField
                                style={{ width: "75%", marginBottom: "24px" }}
                                variant="outlined"
                                label="Leasing Regulations & Restrictions"
                                name='leasingRegulationsAndRestrictions'
                                value={state.leasingRegulationsAndRestrictions || ""}
                                onChange={handleCurrentChange}
                                multiline
                                InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }}
                                InputProps={{ style: { minHeight: "106px" } }}
                                disabled={isProceduresFieldDisabled('leasingRegulationsAndRestrictions')}
                            />
                            <Box mt={"20px"} mb={"20px"}>
                                <div className="text-14px-5B5B5B">Suggested Keywords</div>
                                <Autocomplete
                                    style={{ width: "75%", marginTop: '20px' }}
                                    multiple
                                    id="tags-outlined"
                                    options={config.leasingRestrictionsAndRegulationsKeywords}
                                    getOptionLabel={(option:string) => option}
                                    value={selectedKeywords}
                                    onChange={handleKeywordChange}
                                    disabled={isProceduresFieldDisabled('keywords')}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Keywords"
                                        />
                                    )}
                                />
                            </Box>
                            <Box mt={"20px"} mb={"20px"}>
                                <div className="text-14px-5B5B5B">Categories</div>
                                <div style={{ display: 'flex', marginTop: '20px' }}>
                                    {renderCategories()}
                                </div>
                            </Box>
                        <Box mt={"20px"} mb={"20px"}>
                            <div className="text-14px-5B5B5B">Source Document</div>
                            <Stack flexDirection={"column"}>
                                <Button 
                                    sx={{width:"180px",marginTop: '20px'}}  startIcon={<UploadIcon color="primary"/>} variant="outlined" 
                                    onClick={toggleAttachDocumentModal} disabled={isProceduresFieldDisabled('sourceDocuments')}>
                                    Attach Document
                                </Button>
                            </Stack>
                            {
                                    sourceDocuments?.length > 0 ?
                                    <>
                                    <p className="helperText" style={{fontWeight:"bold"}}>Selected File :</p>
                                    {
                                        Array.from(sourceDocuments).map((item: any, index: number)=> (
                                            item.files.map((file: any, indx: number) => (
                                                <div style={{ cursor: "pointer" }} className="ov-pdf-container" >
                                                    <Stack direction={"row"} alignItems={"center"}>
                                                        <PictureAsPdfIcon style={{ width: "20px", height: "20px" }} />
                                                        <span style={{ marginLeft: "14px" }} className="text-3E3E3E-14px normal">
                                                            {file}
                                                        </span>
                                                    </Stack>
                                                </div>
                                            ))
                                        ))
                                    }
                                    </>
                                    : ''
                                }
                                {
                                    selectedValues.procedures?.sourceDocuments?.length > 0 ?
                                    <>
                                    <p className="helperText" style={{fontWeight:"bold"}}>Uploaded File :</p>
                                    {
                                        Array.from(selectedValues.procedures?.sourceDocuments).map((file : any, index: number)=>{
                                            return <PDFsContainerComponent document={`sourceDocuments`} deleteClick={deleteClick} view={view} key={index} file={file} />
                                        })
                                    }
                                    </>
                                    : ''
                                }
                        </Box>
                        <Box>
                            <TextField
                                    style={{ marginBottom: '24px',width: "433px",}}
                                    multiline
                                    variant="standard"
                                    label={'Reference'}
                                    name='reference'
                                    value={state.reference || ""}
                                    type='text'
                                    onChange={handleCurrentChange}
                                    onWheel={e => Wheel(e)}
                                    InputLabelProps={{ style: { fontSize: "14px" } }}
                                    InputProps={{ style: { padding: "7px 0px" } }}
                                    disabled={isProceduresFieldDisabled('reference')}
                                />
                        </Box>
                    </Stack> 
                        <Stack style={{ borderBottom: '1px solid  #E8E8E8', marginTop: '20px' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        checked={state.leasingCap || false} 
                                        onChange={(event) => handleCurrentChange({ target: { name: 'leasingCap', value: event.target.checked } })} 
                                        disabled={
                                            isProceduresFieldDisabled('leasingCap') ||
                                            isProceduresFieldDisabled('AdditionalInformationOfLeasingCap')
                                        }
                                    />
                                }
                                label="Leasing Cap"
                            />
                            {

                                state.leasingCap &&
                                <TextField
                                    style={{
                                        padding: "10px 0px",
                                        marginTop: "17px",
                                        width: "433px",
                                        marginBottom: '24px'
                                    }}
                                    multiline
                                    variant="standard"
                                    label={'Additional Information'}
                                    name='AdditionalInformationOfLeasingCap'
                                    value={state.AdditionalInformationOfLeasingCap || ""}
                                    type='text'
                                    onChange={handleCurrentChange}
                                    onWheel={e => Wheel(e)}
                                    InputLabelProps={{ style: { fontSize: "14px" } }}
                                    InputProps={{ style: { padding: "7px 0px" } }}
                                    disabled={isProceduresFieldDisabled('AdditionalInformationOfLeasingCap')}
                                />
                            }
                        </Stack>
                        <Stack style={{ borderBottom: '1px solid  #E8E8E8', marginTop: '20px' }}>
                            <CustomDateField 
                                label='Effective Date of Leasing Restriction'
                                error={false}
                                variant="filled"
                                style={{width: '280px', margin: '2px', fontSize: "14px"}}
                                value={dayjs(state.leasingRestrictionDate || "")}
                                handleChange={(value: any)=> {handleDateChange(value, "leasingRestrictionDate")}}
                                disabled={isProceduresFieldDisabled('leasingRestrictionDate')}
                            />
                            <TextField
                                style={{
                                    padding: "10px 0px",
                                    marginTop: "20px",
                                    width: "433px",
                                    marginBottom: '24px'
                                }}
                                multiline
                                variant="standard"
                                label={'Additional Information'}
                                value={state.AdditionalInformationOfDateOfLeasing || ""}
                                type='text'
                                name='AdditionalInformationOfDateOfLeasing'
                                onChange={handleCurrentChange}
                                onWheel={e => Wheel(e)}
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                InputProps={{ style: { padding: "7px 0px" } }}
                                disabled={isProceduresFieldDisabled('AdditionalInformationOfDateOfLeasing')}
                            />
                        </Stack>
                    </div>
                    <div style={{ marginTop: '15px', paddingBottom: '24px' }}>
                        <TextField
                            style={{ width: "433px" }}
                            variant={'standard'}
                            onChange={handleCurrentChange}
                            name='tenantLeaseRegistrationRenewalForm'
                            value={state.tenantLeaseRegistrationRenewalForm || ""}
                            label="Tenant or Lease Registration/Renewal Form"
                            InputLabelProps={{ style: { fontSize: "14px", margin: "4px" } }}
                            helperText={state.tenantLeaseRegistrationRenewalForm?.trim().length > 0 && !isValidHttpUrl(state.tenantLeaseRegistrationRenewalForm as string || '') ? 'Invalid url format' : ''}
                            error={state.tenantLeaseRegistrationRenewalForm?.trim().length > 0 && !isValidHttpUrl(state.tenantLeaseRegistrationRenewalForm as string || '')}
                            disabled={isProceduresFieldDisabled('tenantLeaseRegistrationRenewalForm')}
                            InputProps={{
                                style: { padding: "7px 0px" },
                                endAdornment: (
                                    <InputAdornment position="end" style={{paddingBottom: '7px'}}>
                                        <LinkIcon />
                                    </InputAdornment>
                                )
                            }} />

                        <Stack style={{ marginTop: '20px' }} direction={'row'} justifyContent={'space-between'}>
                            <TextField
                                style={{ width: "433px", }}
                                value={state.registrationAddminFee || ""}
                                onWheel={e => Wheel(e)}
                                variant='standard'
                                type='number'
                                onChange={handleCurrentChange}
                                name='registrationAddminFee'
                                label="Registrations Admin Fee"
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                disabled={isProceduresFieldDisabled('registrationAddminFee')}
                                InputProps={{
                                    style: { padding: "7px 0px" },
                                    endAdornment: (
                                        <InputAdornment position="end" style={{paddingBottom: '7px'}}>
                                            <DollarIcon />
                                        </InputAdornment>
                                    )
                                }} />
                        </Stack>
                    </div>
                </main>
            </div>
            <DeleteAttachmentComp
                open={open}
                setState={setBasicFormState}
                setOpen={setOpen}
                handleClose={handleClose}
                toBeDelete={toBeDelete}
                setToBeDelete={setToBeDelete}
                selectedValues={selectedValues}
                documentName={documentName}
                setDocumentName={setDocumentName}
                currentHoa={currentHoa}
                setCurrentHoa={setCurrentHoa}
                updateSelectedValues={updateSelectedValues}
                sourceDocuments={sourceDocuments}
                setSourceDocuments={setSourceDocuments}
                sourceDocumentsFiles={sourceDocumentsFiles}
                checkProcedureWarning={checkProcedureWarning}
			/>
            {
                isOpen &&
                <SourceIdVerificationModal 
                    open={isOpen}
                    setOpen={setIsOpen}
                    loading={loading}
                    setLoading={setLoading}
                    handleClose={toggleAttachDocumentModal}
                    addNewSourceDocument={addNewSourceDocument}
                    sourceFileInfo={sourceFileInfo}
                    setSourceFileInfo={setSourceFileInfo}
                    handleSourceFile={handleSourceFile}
                    handleDeleteCard={deleteSourceDocument}
                    isAllVerified={isAllVerified}
                    onUploadClick={onUploadClick}
                />
            }
            
        </div>
    )
}

const DeleteAttachmentComp = ({
	open,
	setOpen,
    setState,
	handleClose,
    toBeDelete,
    setToBeDelete,
    documentName,
    setDocumentName,
    selectedValues,
    updateSelectedValues,
    sourceDocuments,
    setCurrentHoa,
    currentHoa,
    setSourceDocuments,
    checkProcedureWarning
}: any) => {
	const [error, setError] = useState({ link: false, files: false });
	const [isLoading, setLoading] = useState(false);

	const handleDelete = async () => {
        if(toBeDelete.name){
            setLoading(true);
            let arr = sourceDocuments.filter((item: any) => {
                return item.name != toBeDelete.name
            })
            setSourceDocuments([...arr])
            setToBeDelete({});
            setDocumentName('');
            setLoading(false);
            handleClose();
            return;
        }

        let arr = selectedValues.procedures.sourceDocuments.filter((item: any) => {
            return item.fileName != toBeDelete.fileName;
        });
        setLoading(true);
        const tempState = {
            ...currentHoa,
            procedures: {
                ...currentHoa['procedures'],
                sourceDocuments: arr
            }
        }
        selectedValues.procedures.sourceDocuments = arr;
        
        setCurrentHoa({...tempState})
        setState({...tempState})
        checkProcedureWarning(tempState);
        updateSelectedValues(selectedValues);
        arr = [];
        setLoading(false);
        handleClose();
	};

	const onClose = () => {
		handleClose();
	};

	return (
		<Modal open={open} onClose={onClose}>
			<Container className="modal-container-style">
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
							<p style={{color: '#787878'}}>This item will be deleted once you save information. It cannot be retrieved afterward</p>
						</div>
					</Stack>

					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
						{!isLoading ? (
							<>
								<Button onClick={() => onClose()} variant="outlined">
									No
								</Button>
								<Button onClick={handleDelete} variant="contained">
									Yes
								</Button>
							</>
						) : (
							<LoadingButton
								loading
								loadingIndicator="Deleting..."
								variant="outlined"
							>
								Deleting Data
							</LoadingButton>
						)}
					</Stack>
				</div>
			</Container>
		</Modal>
	)
}